<template>
  <div :class="['togglebox', {togglebox_expanded: isExpanded}]">
    <div class="togglebox__header">
      <h3>{{opts.toggleboxHeader}}</h3>
      <button :class="[ 'togglebox__expandToggle',{togglebox__expandToggle_expanded: isExpanded}]"  @click="toggleExpand" >{{buttonText}}</button>
      </div>
      <div class="togglebox__category-wrap">
      <category-toggle v-for="category in opts.categories"
      :key="category.id"
      :category="category"


      />
    </div>
  </div>
</template>

<script>

import CategoryToggle from './CategoryToggleVuex.vue';

export default {
  name: 'ToggleBox',
  components : {
    'category-toggle':CategoryToggle
  },
  data () {
    return {
      isExpanded : true,
        isLoaded:false

    }
  },
  methods : {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    }
  },
  computed : {
    buttonText: function(){
      return this.isExpanded ? '-' :'+';
    },
      opts (){
          return this.$store.getters.opts;
      },

  },
  props :[ ]
}
</script>

<style scoped lang="scss">


</style>


// WEBPACK FOOTER //
// src/components/ToggleBoxVuex.vue